import { createFileRoute } from '@tanstack/react-router';

const CLIENT_ID = import.meta.env.VITE_GHL_CLIENT_ID;
const SCOPES = [
  'invoices.readonly',
  'payments/orders.readonly',
  'payments/orders.write',
  'payments/transactions.readonly',
  'products.readonly',
  'products.write',
  'locations.readonly',
  'calendars.readonly',
  'calendars.write',
  'contacts.readonly',
  'contacts.write',
  'products/prices.write',
  'products/prices.readonly',
  'calendars/events.readonly',
  'calendars/events.write',
  'calendars/groups.readonly',
  'calendars/groups.write',
  'calendars/resources.readonly',
  'calendars/resources.write',
  'locations/tags.write',
  'locations/tags.readonly',
  'locations/customFields.readonly',
  'locations/customFields.write',
  'workflows.readonly',
  'locations/customValues.readonly',
  'users.readonly',
  // Conversations: search + create thread + post inbound email (mirror / Send to CRM)
  'conversations.readonly',
  'conversations.write', // POST /conversations/ when no thread exists yet
  'conversations/message.readonly',
  'conversations/message.write',
] as const;

function connectApp() {
  const clientId = encodeURIComponent(CLIENT_ID);

  const scopes = encodeURIComponent(SCOPES.join(' '));

  const queryString = `client_id=${clientId}&scope=${scopes}`;

  // Construct the redirect URI
  const redirectUri = `${import.meta.env.VITE_STUDIO_PORTAL_URL}/authorize`;

  // Construct the full URL for OAuth redirection
  const oauthUrl = `https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${redirectUri}&${queryString}`;

  // Redirect the user to the OAuth URL
  window.location.href = oauthUrl;
}

const component = () => {
  return (
    <div className='flex h-screen w-screen items-center justify-center bg-gray-100'>
      <button
        onClick={() => {
          connectApp();
        }}
        className='m-2 cursor-pointer rounded border-none bg-green-500 px-5 py-3.5 text-white'
      >
        Connect with GoHighLevel!
      </button>
      <button
        onClick={() => {
          throw new Error(`${Date.now()} Test error thrown`);
        }}
        className='m-2 cursor-pointer rounded border-none bg-red-500 px-5 py-3.5 text-white'
      >
        Trigger error
      </button>
    </div>
  );
};

export const Route = createFileRoute('/connect-app')({
  component,
});
